import React, { Component } from 'react';
import Grid from 'material-ui/Grid';
import SwipeableViews from 'react-swipeable-views';
import Tabs, { Tab } from 'material-ui/Tabs';
import TabContainer from "../../shared/TabContainer/TabContainer";
import {Paper} from "material-ui";
import SigninForm from "./SigninForm";
import {connect} from 'react-redux';
import {AuthenticateActions} from "../../actions/authenticate.actions";
import LoginForm from "./LoginForm";

class Authenticate extends Component {
    state = {activeTab: 0};

    handleChange = (e, value) => {
        this.setState({activeTab: value})
    };

    handleChangeIndex = index => {
        this.setState({ activeTab: index });
    };

    redirectAfterSuccess = () => {
        return this.props.history.push('/')
    };

    submitRegister = (values) => {
        this.props.dispatch(AuthenticateActions.signin(values, this.redirectAfterSuccess));
    };

    submitLogin = values => {
        this.props.dispatch(AuthenticateActions.login(values, this.redirectAfterSuccess))
    };

    render(){
        return (
            <Grid container>
                <Grid item md={4} />
                <Grid item md={4} >
                    <Paper elevation={4}>
                        <Tabs
                            value={this.state.activeTab}
                            onChange={this.handleChange}
                            indicatorColor="primary"
                            textColor="primary"
                            fullWidth
                        >
                            <Tab label="Connexion" />
                            <Tab label="Inscription" />
                        </Tabs>
                        <SwipeableViews
                            axis="x"
                            index={this.state.activeTab}
                            onChangeIndex={this.handleChangeIndex}
                        >
                            <TabContainer>
                                <h3>Connectez-vous</h3>
                                <LoginForm
                                    onSubmit={this.submitLogin}
                                    isLoggingIn={this.props.isLoggingIn}
                                />
                            </TabContainer>
                            <TabContainer>
                                <h3>Inscrivez-vous</h3>
                                <SigninForm
                                    onSubmit={this.submitRegister}
                                    isSigningIn={this.props.isSigningIn}
                                />
                            </TabContainer>
                        </SwipeableViews>
                    </Paper>
                </Grid>
            </Grid>
        )
    }
}

function state2props(state){
    return {
        isSigningIn: state.Authenticate.isSigningIn,
        isLoggingIn: state.Authenticate.isLoggingIn
    }
}

export default connect(state2props)(Authenticate);


// WEBPACK FOOTER //
// ./src/pages/authenticate/Authenticate.js